import React, { useState, useRef, useEffect } from 'react';

export const Info_art_tech = ({DetectDevice}) => {
      return (
      <>
     <h5>History</h5>
	 <div className="info-line-container">
              <span className="info-line"></span>
            </div>
	 		<br></br>
	 		In 2014-15, 
			 {' '}
      <a
        href="http://salavon.com/"
        rel="noreferrer"
        target="_blank"
      >Jason Salavon</a>
 		{' '}
			spent the year as
		{' '}
      <a
        href="https://www.microsoft.com/en-us/research/project/bits-of-flow/"
        rel="noreferrer"
        target="_blank"
      >
        Artist-in-Residence at Microsoft Research
      </a>{' '}
			in Redmond, WA. While there, he engaged with researchers' early work on Artificial Neural Network applications with images. Upon returning to Chicago, he immediately acquired some GPUs, built a small team, and was training his own GAN models by the fall of 2015. In 2017, he founded 
			{' '}
      <a
        href="https://latentculture.com/"
        rel="noreferrer"
        target="_blank"
      >
        Latent Culture
      </a>{' '}
			to explore and develop these AI tools for use in visual culture more broadly.
			 <br></br>
	 		That year, we began deploying our in-house GAN models and tile-based rendering techniques for photography and video. We used these innovations in our 
			 {' '}
      <a
        href="https://apps.apple.com/us/developer/jason-salavon-studio/id1347965514"
        rel="noreferrer"
        target="_blank"
      >
        iOS apps
      </a>
	  , consulting with the South Park team on a
	  <a
        href="https://www.nytimes.com/2020/10/29/arts/television/sassy-justice-south-park-deepfake.html"
        rel="noreferrer"
        target="_blank"
      >
    	{' '} deepfake film
      </a>
	 , large-scale art installations, and  
	  <a
        href="http://salavon.com/work/sensorium/"
        rel="noreferrer"
        target="_blank"
      >
        {' '} published research
      </a>
	  . Our in-house model, Genmo, was awarded a  
	  <a
        href="http://salavon.com/work/patent/"
        rel="noreferrer"
        target="_blank"
      >
        {' '} U.S. patent {' '}
      </a>
	  in 2020. Another in-house model, Sensorium (which anticipates ControlNet) was published at 
	  <a
        href="https://iccv2021.thecvf.com/home"
        rel="noreferrer"
        target="_blank"
      >
        {' '} ICCV 2021
		</a>
		.
			<br></br>
			
			<div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
			{!DetectDevice ? (
				<>
			    <div style={{paddingRight: "40px", paddingLeft: "90px", paddingTop: "10px", paddingBottom: "10px" }}>
			        <img
			            src="https://www.latentculture.com/tohm/images/arttech4.jpeg"
			            width="220px" height="220px"
			            alt="Jason Salavon Art"
			            style={{ opacity: 1 }}
			        />
					<br></br>
			        <p style={{fontSize: "12px"}}> An image recomposed from flowers, 
					made with Genmo.</p>
			    </div>
			    <div style={{paddingRight: "90px", paddingLeft: "40px", paddingTop: "10px", paddingBottom: "10px"}}>
			        <img
			            src="https://www.latentculture.com/tohm/images/arttech5.jpeg"
			            width="220px" height="220px"
			            alt="Jason Salavon Art"
			            style={{ opacity: 1 }}
			        />
					<br></br>
			        <p style={{fontSize: "12px"}}> Salavon’s Genmo neural network patent.</p>
			    </div>
			    </>
			  ) : (
			  	<>
				<div style={{paddingTop: "10px", paddingBottom: "10px"}}>
				    <img
				        src="https://www.latentculture.com/tohm/images/arttech4.jpeg"
				        width="220px" height="220px"
				        alt="Jason Salavon Art"
				        style={{ opacity: 1, display: "block", marginLeft: "auto", marginRight: "auto" }}
				    />
				    <p style={{fontSize: "12px", textAlign: "center"}}> An image recomposed from flowers, made with Genmo.</p>
				    <img
				        src="https://www.latentculture.com/tohm/images/arttech5.jpeg"
				        width="220px" height="220px"
				        alt="Jason Salavon Art"
				        style={{ opacity: 1, display: "block", marginLeft: "auto", marginRight: "auto", marginTop: "20px" }}
				    />
				    <p style={{fontSize: "12px", textAlign: "center"}}> Salavon’s Genmo neural network patent.</p>
				</div>
				</>
				)}
			</div>
			Held by museums including the Museum of Modern Art, the Whitney, and LACMA, among many others, Jason Salavon’s work has pioneered utilizing data and code for fine art since the 1990s. His work has long explored populations, distributions, and generating "little infinities" through creating, arranging, and synthesizing expansive quantities of images and video.
			<br></br>
			<div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
			{!DetectDevice ? (
				<>
			    <div style={{paddingRight: "10px", paddingLeft: "10px", paddingTop: "10px", paddingBottom: "10px" }}>
			        <img
			            src="https://www.latentculture.com/tohm/images/arttech1.png"
			            width="220px" height="220px"
			            alt="Jason Salavon Art"
			            style={{ opacity: 1 }}
			        />
					<br></br>
			        <p style={{fontSize: "12px"}}>One frame per second of <i>Star Wars</i> arranged by luminosity in <i>The Grand Unification Theory (Part One: Every Second of Star Wars)</i>, 1997.</p>
			    </div>
			    <div style={{paddingRight: "25px", paddingLeft: "10px", paddingTop: "10px", paddingBottom: "25px" }}>
			        <img
			            src="https://www.latentculture.com/tohm/images/arttech3.png"
			            width="auto" height="220px"
			            alt="Jason Salavon Art"
			            style={{ opacity: 1 }}
			        />
					<br></br>
			        <p style={{fontSize: "12px"}}>The average of Franz Hals portrait oeuvre, part of <i>Portrait</i>, 2009/2010.</p>
			    </div>
			    <div style={{paddingRight: "10px", paddingLeft: "10px", paddingTop: "10px", paddingBottom: "25px" }}>
			        <img
			            src="https://www.latentculture.com/tohm/images/arttech2.png"
			            width="220px" height="220px"
			            alt="Jason Salavon Art"
			            style={{ opacity: 1 }}
			        />
					<br></br>
			        <p style={{fontSize: "12px"}}> Excerpt from <i>100,000 Abstract Paintings</i>, digitally generated paintings made from custom software, 2001.</p>
			    </div>
			    </>
			  ) : (
			  	<>
					<div style={{paddingLeft: "10px", paddingTop: "10px", paddingBottom: "25px"}}>
					    <img
					        src="https://www.latentculture.com/tohm/images/arttech1.png"
					        width="220px" height="220px"
					        alt="Jason Salavon Art"
					        style={{ opacity: 1, display: "block", marginLeft: "auto", marginRight: "auto" }}
					    />
					    <p style={{fontSize: "12px", textAlign: "center"}}>One frame per second of <i>Star Wars</i> arranged by luminosity in <i>The Grand Unification Theory (Part One: Every Second of Star Wars)</i>, 1997.</p>
					    <img
					        src="https://www.latentculture.com/tohm/images/arttech3.png"
					        width="220px" height="220px"
					        alt="Jason Salavon Art"
					        style={{ opacity: 1, display: "block", marginLeft: "auto", marginRight: "auto", marginTop: "20px" }}
					    />
					    <p style={{fontSize: "12px", textAlign: "center"}}>The average of Franz Hals portrait oeuvre, part of <i>Portrait</i>, 2009/2010.</p>
					    <img
					        src="https://www.latentculture.com/tohm/images/arttech2.png"
					        width="220px" height="220px"
					        alt="Jason Salavon Art"
					        style={{ opacity: 1, display: "block", marginLeft: "auto", marginRight: "auto", marginTop: "20px" }}
					    />
					    <p style={{fontSize: "12px", textAlign: "center"}}> Excerpt from <i>100,000 Abstract Paintings</i>, digitally generated paintings made from custom software, 2001.</p>
					</div>
				</>
				)}	
			</div>
			Wanting to expand Genmo's tiling into a large-scale video format, Salavon created 
			<a
        href="http://salavon.com/work/homage-between/"
        rel="noreferrer"
        target="_blank"
      >
        {' '} <i>Homage in Between</i>
      </a>
			, a 6k projection-mapped video commissioned for Chicago’s inaugural Art on the Mart in 2018.
			<br></br>
			<div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
			    <div style={{paddingRight: "10px", paddingLeft: "10px", paddingTop: "10px", paddingBottom: "10px" }}>
			        <img
			            src="https://www.latentculture.com/tohm/images/arttech6.png"
			            width={!DetectDevice ? "600px" : "300px"} height={!DetectDevice ? "348px" : "174px"}
			            alt="Jason Salavon Art"
			            style={{ opacity: 1 }}
			        />
					<br></br>
			        <p style={{fontSize: "12px"}}> A still from  <i>Homage in Between</i>, exhibited at Art on the Mart in 2018. </p>
			    </div>
			</div> 
			In 2020, Salavon’s 72-foot piece 
			<a
        href="http://salavon.com/work/little-infinity-v-mfahmap/"
        rel="noreferrer"
        target="_blank"
      >
        {' '} <i>Little Infinity (v.MFAH)</i>
      </a>
			, commissioned by the Museum of Fine Arts, Houston, continued exploring giga-scale image creation by sampling over 300,000 images from ImageNet’s dataset and arranging them along semantic and color gradients.
			<br></br>
			<div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
			{!DetectDevice ? (
				<>
			    <div style={{paddingRight: "5px", paddingLeft: "10px", paddingTop: "10px", paddingBottom: "10px" }}>
			        <img
			            src="https://www.latentculture.com/tohm/images/arttech7.png"
			            width="auto" height="225px"
			            alt="Jason Salavon Art"
			            style={{ opacity: 1 }}
			        />
					<br></br>
			        <p style={{fontSize: "12px"}}> Detail from <i>Little Infinity (v.MFAH)</i>, 2020. </p>
			    </div>
			    <div style={{paddingRight: "30px", paddingLeft: "30px", paddingTop: "30px", paddingBottom: "10px" }}>
			        <img
			            src="https://www.latentculture.com/tohm/images/arttech8.jpeg"
			            width="auto" height="225px"
			            alt="Jason Salavon Art"
			            style={{ opacity: 1 }}
			        />
					<br></br>
			        <p style={{fontSize: "12px"}}> <i>Little Infinity (v.MFAH)</i> installation at the Museum of Fine Arts, Houston, 2020. </p>
			    </div>
			 	</>
				) : (
			  	<>
					<div style={{paddingLeft: "10px", paddingTop: "10px", paddingBottom: "10px"}}>
					    <img
					        src="https://www.latentculture.com/tohm/images/arttech7.png"
					        width="220px"
					        height="225px"
					        alt="Jason Salavon Art"
					        style={{ opacity: 1, display: "block", marginLeft: "auto", marginRight: "auto" }}
					    />
					    <p style={{fontSize: "12px", textAlign: "center"}}> Detail from <i>Little Infinity (v.MFAH)</i>, 2020. </p>
					    <img
					        src="https://www.latentculture.com/tohm/images/arttech8.jpeg"
					        width="220px"
					        height="225px"
					        alt="Jason Salavon Art"
					        style={{ opacity: 1, display: "block", marginLeft: "auto", marginRight: "auto", marginTop: "20px" }}
					    />
					    <p style={{fontSize: "12px", textAlign: "center"}}> <i>Little Infinity (v.MFAH)</i> installation at the Museum of Fine Arts, Houston, 2020. </p>
					</div>
				</>
				)}
			</div>
			These projects and their innovations paved the way for the creation of <i>TODEM</i>. 
			<br></br>

		<h5>Ideas & Intentions</h5>
		<div className="info-line-container">
              <span className="info-line"></span>
            </div>

		<br></br>
		Over a year in the making, <i>TODEM (Tapestry of Decadent Meritocracy)</i> represents true innovation in using AI and blockchain in art. Instead of using the basic outputs of pre-existing AI models, we wanted to examine the limits of the tools and the forces shaping them. From its inception, we aimed to create a giga-scale animation while exploring the possibilities of digitally native art. 
      	<br></br>
		  Formally, we were interested in the emergence of blockchain as a new artistic medium and wanted to experiment with the creative potential and participatory nature of NFTs. The result is perhaps our most ambitious fusion of large-scale data synthesis and generative AI technologies yet: a 100K x 58K pixel animation, totaling 14 hours and 31 minutes of AI-generated content, quite possibly the largest GIF in the world.
		  <br></br>
		  Thematically, <i>TODEM</i> explores the relationships between wealth, merit, popularity, and power in Western culture. Because the internet is a product of these forces and reflects their influences, we use it as a proxy for Western civilization. The large-scale images underlying the Tapestry move from Enlightenment figures and Renaissance artworks to modern-day culture, depicting a narrative about the evolution of Western culture that questions what is considered significant and why. This concept is integral to <i>TODEM's</i> structure: many larger images portray iconic images, while the thousands of smaller Tile and subtile images were determined by the top-viewed English-language Wikipedia pages from 2021-2022. By building images of people and artworks considered “significant” out of what was democratically determined to be culturally relevant, <i>TODEM</i> explores the themes of polarity, amorality, and meritocracy in its form and content.
      <br></br>

	  <h5>Influences & Resources</h5>
		<div className="info-line-container">
              <span className="info-line"></span>
            </div>
		<br></br>
		We proudly stand on the shoulders of giants. <i>TODEM</i> is the synthesis of years of Salavon's art practice and the influence of artists, projects, technologies, and ideas spanning centuries.
		<br></br>
		Artistically, there is obvious debt to Hans Hoffman, Sol Lewitt, John Cage, as well as Hieronymus Bosch and Pieter Bruegel the Elder. But this work bears the mark of many other ideas and projects, including the Kunstkammer, r/place, knolling, and the Million Dollar Homepage.
		<br></br>
		<i>TODEM</i> also leverages many publicly available resources, including Wikipedia, FFHQ & MIRFLICKR, and the Federal Reserve Bank of St. Louis for prompt kernels, image datasets, and economic data. Additionally, we used open-source tools and platforms like Deforum, GPT-3.5, Open Zeppelin, and Stable Diffusion.
		<br></br>
		
		<h5>Construction</h5>
		<div className="info-line-container">
              <span className="info-line"></span>
            </div>

		<br></br>
		<i>TODEM</i> is a 100K by 58K pixel canvas divided into 1,000 Tiles, and those Tiles are composed of 5,226 subtiles. 
		<br></br>
		<h6>Tiles</h6>
		The Tiles are non-uniform in dimension and number of pixels. They are labeled according to size, where Tile 0000 is the largest and Tile 0999 is the smallest. The number of pixels per Tile reflects U.S. wealth distribution data from 2022, ranging from 100+ to 100,000,000+ pixels in each Tile. Following this wealth data, the Tiles are grouped into 4 Classes: 10 Class A Tiles (top 1%), 90 Class B Tiles (rest of top 10%), 400 Class C Tiles (rest of top 50%), and 500 Class D Tiles (bottom 50%). Class A Tiles occupy over 30% of the total pixel area, while Class D Tiles claim only 3% of the pixels. The result is higher-class Tiles claiming more space in the Tapestry and possessing higher resolution images, while lower-class Tiles are smaller with lower resolution images. 
		<br></br>
		The image sources for the Tiles vary by class, resulting in different traits for every Tile class. 
		<br></br>
		Salavon chose the images, placement, and labels for all Class A Tiles (0000-0009), Class B Tiles (0010-0099), and Tile 0100. The images for Class C Tiles (0100-0499) are sourced from two different datasets. Tiles 0101-0299 come from Jason Salavon Studio’s own in-house datasets and are labeled JSS accordingly. Tiles 0300-0499 are drawn from the FFHQ face dataset. The images for Class D Tiles (0500-0999) are pulled from the MIRFLICKR dataset. This means that the higher-class Tiles have more deliberate artistic intent, while the lower-class Tiles sample randomly from datasets of preexisting images.
		<br></br>
		Each Tile is mintable on the Ethereum blockchain as an NFT. While these form a collection, each Tile is distinct in value and intent. Tiles possess multiple traits, including token ID, dimensions, number of pixels, label, triptych location, class, number of subtitles, and prompts. The NFT price of each Tile reflects the same distribution of wealth in the U.S. by following per-pixel pricing, with prices ranging from 0.00025 ETH to 66.16763 ETH. We committed to this unconventional pricing structure to expand the pricing possibilities for digital assets and clearly reflect existing wealth disparities. 
		<br></br>
		<h6>Subtiles</h6>
		The subtile animations are made by synthesizing AI-generated text prompts with deconstructed image data. We coded a prompt generator using the subjects of the 5,226 most popular English-language Wikipedia pages (by pageview) from 2021-2022. We combined these prompts with shape and color data from the underlying canvas. The result is the subtiles move between their individual images and merge with other subtiles to form the Tile and broader images throughout the animation. The subtile number corresponds to its pageview ranking, and the subtiles are distributed semi-randomly throughout, but it's more likely that large Tiles contain large subtiles. This means that the largest Tiles contain the most popular ideas and images from Western culture.
		<br></br>
		We wanted to embrace the quirks that arise from randomness so there is variation within all these patterns. For example, there isn't a rigid relationship between the Tile number and the number of subtiles in each Tile. This means that some smaller Tiles may have a disproportionate number of subtiles. Similarly, the popularity of a Wikipedia page does not strictly determine what Tile the subtile is in. When working with large datasets and algorithms, we view randomness as a contour that can be shaped to influence the final work.
		<br></br>
		<h6>Versions</h6>
		There are three released versions of <i>TODEM</i>: v14, v42, and v56.  Initially, in June 2023, we released v42 as the gold master version of the Tapestry. But over time, we couldn’t help ourselves and rendered just a few more versions, bringing new learnings to each new pass.
		<br></br>
		At present, we've rendered approximately 56 different passes, with each one averaging about a week to produce. Ultimately, we decided to release v14 and v56 to share earlier and latest versions. Making <i>TODEM</i> was a labor-intensive, iterative process and we wanted to foreground that journey. 
		<br></br>
		<h5>Key Frames</h5>
		<div className="info-line-container">
              <span className="info-line"></span>
            </div>

		<br></br>
		<i>TODEM</i> consists of 100 frames of AI-generated animation running on a continuous loop. A few frames are essential to understanding its themes and intentions.
		<br></br>
		<div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
		    	<div style={{paddingRight: "10px", paddingLeft: "10px", paddingTop: "10px", paddingBottom: "10px" }}>
		        <img
		            src="https://www.latentculture.com/tohm/images/arttech9.png"
		            width={!DetectDevice ? "600px" : "300px"} height={!DetectDevice ? "348px" : "174px"}
		            alt="Jason Salavon Art"
		            style={{ opacity: 1 }}
		        />
				<br></br>
				</div>
		</div> 
		Frame 0: In this frame, every subtile image originates from the same prompt, “A Tapestry of Decadent Meritocracy.” The Tiles are reconstructing a noisy rainbow gradient, a frequent theme in Salavon’s work.
		    <br></br>
		<div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
			    <div style={{paddingRight: "10px", paddingLeft: "10px", paddingTop: "10px", paddingBottom: "10px" }}>
		        <img
		            src="https://www.latentculture.com/tohm/images/arttech10.png"
		            width={!DetectDevice ? "600px" : "300px"} height={!DetectDevice ? "348px" : "174px"}
		            alt="Jason Salavon Art"
		            style={{ opacity: 1 }}
		        />
				<br></br>
				</div>
		</div>
		Frame 33: All the Tile base images are fully reconstructed here, showcasing the composition of the Classes and Tiles and the range of image content. These are the "label" trait.
		   <br></br>
		<div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
		    	<div style={{paddingRight: "10px", paddingLeft: "10px", paddingTop: "10px", paddingBottom: "10px" }}>
		        <img
		            src="https://www.latentculture.com/tohm/images/arttech11.png"
		            width={!DetectDevice ? "600px" : "300px"} height={!DetectDevice ? "348px" : "174px"}
		            alt="Jason Salavon Art"
		            style={{ opacity: 1 }}
		        />
				<br></br>
				</div>
		</div>
		Frame 67: A painting-style triptych held within a gilded frame. Pope Leo X (Medici scion) is on the left, Isaac Newton on the right, and a collage of Triptych of the Temptation of St. Anthony (c.1501) by Hieronymus Bosch and The Harvesters (c.1565) by Pieter Bruegel the Elder in the center. In combining these symbols of Western religion, commerce, art, and science, Frame 67 suggests a narrative of Western society that questions how power, wealth, innovation, and fame function within it.
		<br></br>
      </>
)}

export default Info_art_tech; 